/**
 * Typed provider encryption keys API facade over the generated contract client.
 */

import { providerEncryptionKeysApi } from '../api/generated/providerEncryptionKeys.api.js';
import type {
  GetEncryptionKeyResponse,
  ListEncryptionKeysResponse,
} from './EncryptionKeysService.js';

class ProviderEncryptionKeysService {
  async listEncryptionKeys(params?: {
    status?: string;
    tenantId?: string;
    limit?: number;
    offset?: number;
  }): Promise<ListEncryptionKeysResponse> {
    return providerEncryptionKeysApi.list(params ?? {}) as Promise<ListEncryptionKeysResponse>;
  }

  async getEncryptionKey(keyId: string): Promise<GetEncryptionKeyResponse> {
    return providerEncryptionKeysApi.getById(keyId) as Promise<GetEncryptionKeyResponse>;
  }
}

export const providerEncryptionKeysService = new ProviderEncryptionKeysService();
